import React, { useState } from "react";
import classNames from "classnames";

import styles from "./Event.module.scss";
import { Icon } from "../Icon";
import { Expandable } from "../Expandable";
import Markdown from "markdown-to-jsx";
import { CreativeMarkdown } from "../CreativeMarkdown";

interface EventItemProps {
  className?: string;
  title: string;
  subtitle?: string;
  description: string;
  link?: string;
}

const EventItem: React.FC<EventItemProps> = ({
  className,
  title,
  subtitle,
  description,
  link,
}) => {
  const [expand, setExpand] = useState(true);

  return (
    <div
      className={classNames(
        styles.event,
        { [styles.expanded]: expand },
        className
      )}
    >
      <div
        className={styles.top}
        role="button"
        onClick={() => setExpand(!expand)}
      >
        <p className={styles.title}>{title}</p>
        <p className={styles.time}>{subtitle}</p>
        <div className={styles.icon}>
          <Icon className={styles.iconActual} name="chevron-down" />
        </div>
      </div>
      <Expandable className={styles.description} open={expand}>
        <CreativeMarkdown
          className={styles.descriptionInner}
          options={{ forceBlock: true }}
        >
          {description}
        </CreativeMarkdown>
        {link && (
          <a href={link} target="_blank" rel="noreferrer noopener">
            Info link
          </a>
        )}
      </Expandable>
    </div>
  );
};

export { EventItem };
